import * as React from "react";

const CheckIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12">
    <path
      fill="#171718"
      d="M4.658 8.817 1.183 5.342 0 6.517l4.658 4.658 10-10L13.483 0z"
    ></path>
  </svg>
);

export default CheckIconSVG;
